module.exports = __webpack_public_path__ + "img/h_product_66.db8a1d1.jpg";